import React  from 'react';
import App from './App';

import './common/styles/index.scss';
import ReactDOM from 'react-dom';

const ELEMENT_ID = 'delivery-coordination-dashboard';

class WebComponent extends HTMLElement {
	connectedCallback() {
		ReactDOM.render(
			<App />, this
		);
	}
}

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, WebComponent);
}
